import React, { useState } from 'react';
import {
  TextField,
  Button,
  CircularProgress,
  InputAdornment,
  IconButton,
  Alert,
  AlertTitle,
  Typography,
} from '@mui/material';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { callApi } from 'src/core/callApi';
import './resetPassword.scss';
import { COLOR_PRIMARY, COLOR_PRIMARY_DARK } from 'src/utils/const';
import { useLocation } from 'react-router-dom';

const ResetPasswordConfirmation = () => {
  const [password, setPassword] = useState<string>('');
  const [confirmPassword, setConfirmPassword] = useState<string>('');
  const [passwordReseted, setPasswordReseted] = useState<boolean>(false);
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState<boolean>(false);
  const [alertMesaage, setAlertMessage] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(false);

  const location = useLocation();

  const inputStyle = {
    width: '100%',
    marginBottom: 2,
    '& input:valid + fieldset': {
      borderColor: '#bebebe',
      borderWidth: 2,
    },
    '& input:invalid + fieldset': {
      borderColor: 'red',
      borderWidth: 2,
    },
    '& input:valid:focus + fieldset': {
      borderColor: '#bebebe',
      borderLeftWidth: 6,
      padding: '4px !important',
    },
  };

  // console.log(window.location.href.split('//')[1].split('/')[0], '<><>');

  const handleSubmit = async () => {
    if (password.trim() !== confirmPassword.trim()) {
      setAlertMessage('Password are not matching !');
      return null;
    }
    if (password.trim() === '') {
      setAlertMessage('Password can not be empty !');
      return null;
    }

    if (passwordReseted) return null;

    const token = location.pathname.split('/')[2];

    setLoading(true);

    const url = 'https://bwb70jlw69.execute-api.us-east-2.amazonaws.com/default/resetPassword';
    const config = {
      body: [
        {
          reset: true,
          password: password.trim(),
          token: token,
        },
      ],
      method: 'post',
    };

    try {
      const response = await callApi(url, config, false);
      if (response && response.success) {
        setLoading(false);
        setPasswordReseted(true);
      } else if (response && response.error) {
        setLoading(false);
        setAlertMessage(response.error);
      } else {
        setLoading(false);
        setAlertMessage(
          'Your link is probably expired, please generate a new link from forgot password in login or sign up page!'
        );
      }
    } catch (err) {
      setLoading(false);
      if (err instanceof Error) {
        setAlertMessage(err.message);
      }
    }

    return null;
  };

  return (
    <>
      <div className="resetPasswordContainer">
        <div className="center">
          <TextField
            label="New Password"
            variant="outlined"
            type={showPassword ? 'text' : 'password'}
            value={password}
            disabled={loading || passwordReseted}
            onChange={e => {
              setPassword(e.target.value);
            }}
            sx={inputStyle}
            color="info"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={() => setShowPassword(prev => !prev)}
                  >
                    {showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <TextField
            label="Confirm Password"
            variant="outlined"
            type={showConfirmPassword ? 'text' : 'password'}
            value={confirmPassword}
            disabled={loading || passwordReseted}
            onChange={e => {
              setConfirmPassword(e.target.value);
            }}
            sx={inputStyle}
            color="info"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={() => setShowConfirmPassword(prev => !prev)}
                  >
                    {showConfirmPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <Button
            variant="contained"
            onClick={handleSubmit}
            sx={{
              marginTop: 2,
              boxSizing: 'border-box',
              padding: 0,
              width: passwordReseted ? '100px !important' : '100%',
              height: passwordReseted ? '100px !important' : '50px',
              background: COLOR_PRIMARY,
              borderRadius: '100px',
              fontSize: '18px',
              '&:hover': {
                background: COLOR_PRIMARY_DARK,
              },
              ['@media (max-width:670px)']: {
                fontSize: '14px',
              },
            }}
          >
            {loading ? (
              <CircularProgress
                size={20}
                sx={{
                  color: '#fff',
                }}
              />
            ) : passwordReseted ? (
              <DoneIcon sx={{ width: '60px', height: '60px' }} />
            ) : (
              'Reset Password'
            )}
          </Button>

          {alertMesaage && (
            <Alert
              severity="error"
              sx={{
                width: '90%',
                marginTop: 6,
                animation: 'fadeIn 0.3s ease forwards',
              }}
              action={
                <IconButton
                  aria-label="close"
                  color="inherit"
                  size="small"
                  onClick={() => {
                    setAlertMessage(null);
                  }}
                >
                  <CloseIcon fontSize="inherit" />
                </IconButton>
              }
            >
              <AlertTitle>Error</AlertTitle>
              {alertMesaage}
            </Alert>
          )}
          {passwordReseted && (
            <a href="/" style={{ textDecoration: 'none' }}>
              <Typography
                variant="body1"
                gutterBottom
                component="p"
                sx={{
                  textAlign: 'center',
                  marginTop: 4,
                  color: COLOR_PRIMARY_DARK,
                  fontWeight: 500,
                  fontSize: '20px',
                }}
              >
                Return to Login
              </Typography>
            </a>
          )}
        </div>
      </div>
    </>
  );
};

export default ResetPasswordConfirmation;
